export const arrow = (
  <svg
    className="hover:fill-[#012169]"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="#9CA3AF"
  >
    <path
      d="M6.9999 7.3998C6.8499 7.3998 6.7249 7.3498 6.5999 7.2498L0.849902 1.5998C0.624902 1.3748 0.624902 1.0248 0.849902 0.799805C1.0749 0.574805 1.4249 0.574805 1.6499 0.799805L6.9999 6.0248L12.3499 0.749805C12.5749 0.524805 12.9249 0.524805 13.1499 0.749805C13.3749 0.974805 13.3749 1.3248 13.1499 1.5498L7.3999 7.1998C7.2749 7.3248 7.1499 7.3998 6.9999 7.3998Z"
    />
  </svg>
);

export const close = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_500_8243)">
      <path d="M8.00039 7.2001L1.90039 1.1001C1.67539 0.875097 1.32539 0.875097 1.10039 1.1001C0.875391 1.3251 0.875391 1.6751 1.10039 1.9001L7.20039 8.0001L1.10039 14.1001C0.875391 14.3251 0.875391 14.6751 1.10039 14.9001C1.32539 15.1251 1.67539 15.1251 1.90039 14.9001L8.00039 8.8001L14.1004 14.9001C14.3254 15.1251 14.6754 15.1251 14.9004 14.9001C15.0004 14.8001 15.0754 14.6501 15.0754 14.5001C15.0754 14.3501 15.0254 14.2001 14.9004 14.1001L8.80039 8.0001L14.9004 1.9001C15.0004 1.8001 15.0754 1.6501 15.0754 1.5001C15.0754 1.3501 15.0254 1.2001 14.9004 1.1001C14.6754 0.875097 14.3254 0.875097 14.1004 1.1001L8.00039 7.2001Z" fill="#637381"/>
    </g>
    <defs>
      <clipPath id="clip0_500_8243">
      <rect width="16" height="16" fill="white" transform="translate(0 16) rotate(-90)"/>
      </clipPath>
    </defs>
  </svg>
)

export const closeSmall = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clip-path="url(#clip0_500_8255)">
      <path d="M5.9998 5.4002L1.4248 0.825195C1.25605 0.656446 0.993555 0.656446 0.824805 0.825195C0.656055 0.993945 0.656055 1.25644 0.824805 1.42519L5.3998 6.0002L0.824805 10.5752C0.656055 10.7439 0.656055 11.0064 0.824805 11.1752C0.993555 11.3439 1.25605 11.3439 1.4248 11.1752L5.9998 6.6002L10.5748 11.1752C10.7436 11.3439 11.0061 11.3439 11.1748 11.1752C11.2498 11.1002 11.3061 10.9877 11.3061 10.8752C11.3061 10.7627 11.2686 10.6502 11.1748 10.5752L6.5998 6.0002L11.1748 1.42519C11.2498 1.3502 11.3061 1.23769 11.3061 1.12519C11.3061 1.0127 11.2686 0.900195 11.1748 0.825195C11.0061 0.656446 10.7436 0.656446 10.5748 0.825195L5.9998 5.4002Z" fill="#637381"/>
    </g>

    <defs>
      <clipPath id="clip0_500_8255">
      <rect width="12" height="12" fill="white" transform="translate(0 12) rotate(-90)"/>
      </clipPath>
    </defs>
  </svg>
)

export const arrowVertical = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.7955 1.20451C8.35616 0.765165 7.64384 0.765165 7.20451 1.20451L1.20451 7.2045C0.993527 7.41548 0.875 7.70163 0.875 8C0.875 8.29837 0.993527 8.58452 1.20451 8.79549L7.2045 14.7955C7.64384 15.2348 8.35616 15.2348 8.7955 14.7955C9.23483 14.3562 9.23483 13.6438 8.7955 13.2045L3.59099 8L8.7955 2.7955C9.23484 2.35616 9.23484 1.64384 8.7955 1.20451Z"
      fill="#1F2A37"
    />
  </svg>
);

export const link = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.0749 4.02539L8.19985 4.02539C6.69985 4.02539 5.47485 5.25039 5.47485 6.75039V6.87539C5.47485 8.37539 6.69985 9.60039 8.19985 9.60039H8.59985V8.50039H8.19985C7.32485 8.50039 6.59985 7.77539 6.59985 6.90039V6.75039C6.59985 5.87539 7.32485 5.15039 8.19985 5.15039L13.0749 5.15039C13.9499 5.15039 14.6749 5.87539 14.6749 6.75039V6.87539C14.6749 7.75039 13.9499 8.47539 13.0749 8.47539H11.1249V9.60039H13.0749C14.5749 9.60039 15.7999 8.37539 15.7999 6.87539V6.75039C15.8249 5.25039 14.5999 4.02539 13.0749 4.02539Z"
      fill="#9CA3AF"
    />
    <path
      d="M7.79995 6.375H7.37495V7.5H7.79995C8.67495 7.5 9.39995 8.225 9.39995 9.1V9.25C9.39995 10.125 8.67495 10.85 7.79995 10.85H2.92495C2.04995 10.85 1.32495 10.125 1.32495 9.25V9.125C1.32495 8.25 2.04995 7.525 2.92495 7.525L4.82495 7.525V6.4L2.92495 6.4C1.42495 6.4 0.199951 7.625 0.199951 9.125L0.199951 9.25C0.199951 10.75 1.42495 11.975 2.92495 11.975H7.79995C9.29995 11.975 10.525 10.75 10.525 9.25V9.125C10.525 7.6 9.29995 6.375 7.79995 6.375Z"
      fill="#9CA3AF"
    />
  </svg>
);

export const circle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_2105_19433)">
      <path
        d="M7.97586 4.87305H7.95162C7.66071 4.87305 7.39404 5.11547 7.39404 5.43062C7.39404 5.74577 7.63647 5.9882 7.95162 5.9882H7.97586C8.26677 5.9882 8.53344 5.74577 8.53344 5.43062C8.53344 5.11547 8.29101 4.87305 7.97586 4.87305Z"
        fill="#9CA3AF"
      />
      <path
        d="M7.97579 6.78809C7.68488 6.78809 7.41821 7.03051 7.41821 7.34566L7.41821 11.079C7.41821 11.3699 7.66064 11.6366 7.97579 11.6366C8.2667 11.6366 8.53336 11.3941 8.53336 11.079V7.32142C8.53336 7.03051 8.29094 6.78809 7.97579 6.78809Z"
        fill="#9CA3AF"
      />
      <path
        d="M7.97583 0.678711C3.92734 0.678711 0.630371 3.95144 0.630371 7.99992C0.630371 12.0484 3.92734 15.3454 7.97583 15.3454C12.0243 15.3454 15.297 12.0484 15.297 7.99992C15.297 3.95144 12.0243 0.678711 7.97583 0.678711ZM7.97583 14.2545C4.5334 14.2545 1.72128 11.4423 1.72128 7.99992C1.72128 4.5575 4.5334 1.74538 7.97583 1.74538C11.4183 1.74538 14.2061 4.5575 14.2061 7.99992C14.2061 11.4423 11.4183 14.2545 7.97583 14.2545Z"
        fill="#9CA3AF"
      />
    </g>
    <defs>
      <clipPath id="clip0_2105_19433">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const arrowDouble = (
  <svg
    className="hover:fill-[#012169]"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="#9CA3AF"
  >
    <path
      d="M6.5999 7.6002C6.6999 7.7002 6.8499 7.7502 6.9999 7.7502C7.1499 7.7502 7.2749 7.7002 7.3999 7.6002L13.1499 1.9502C13.3749 1.7252 13.3749 1.3752 13.1499 1.1502C12.9249 0.925195 12.5749 0.925195 12.3499 1.1502L6.9999 6.4002L1.6499 1.1502C1.4249 0.925195 1.0749 0.925195 0.849902 1.1502C0.624902 1.3752 0.624902 1.7252 0.849902 1.9502L6.5999 7.6002Z"
    />
    <path
      d="M12.3499 4.4002L6.9999 9.65019L1.6499 4.4002C1.4249 4.1752 1.0749 4.1752 0.849902 4.4002C0.624902 4.6252 0.624902 4.9752 0.849902 5.2002L6.5999 10.8502C6.6999 10.9502 6.8499 11.0002 6.9999 11.0002C7.1499 11.0002 7.2749 10.9502 7.3999 10.8502L13.1499 5.2002C13.3749 4.9752 13.3749 4.6252 13.1499 4.4002C12.9249 4.1752 12.5749 4.1752 12.3499 4.4002Z"
    />
  </svg>
);

export const download = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_2180_42077)">
      <path
        d="M18.75 13.75C18.375 13.75 18.0313 14.0625 18.0313 14.4687V17.25C18.0313 17.5313 17.8125 17.75 17.5312 17.75H2.46875C2.1875 17.75 1.96875 17.5313 1.96875 17.25V14.4687C1.96875 14.0625 1.625 13.75 1.25 13.75C0.875 13.75 0.53125 14.0625 0.53125 14.4687V17.25C0.53125 18.3125 1.375 19.1563 2.4375 19.1563H17.5312C18.5938 19.1563 19.4375 18.3125 19.4375 17.25V14.4687C19.4688 14.0625 19.125 13.75 18.75 13.75Z"
        fill="#012169"
      />
      <path
        d="M9.50017 14.5313C9.62517 14.6563 9.81267 14.7188 10.0002 14.7188C10.1877 14.7188 10.3439 14.6563 10.5002 14.5313L15.0314 10.125C15.3127 9.84375 15.3127 9.40625 15.0314 9.125C14.7502 8.84375 14.3127 8.84375 14.0314 9.125L10.7189 12.375V1.5625C10.7189 1.1875 10.4064 0.84375 10.0002 0.84375C9.62517 0.84375 9.28142 1.15625 9.28142 1.5625V12.375L5.96892 9.125C5.68767 8.84375 5.25017 8.875 4.96892 9.125C4.68767 9.40625 4.71892 9.84375 4.96892 10.125L9.50017 14.5313Z"
        fill="#111928"
      />
    </g>
    <defs>
      <clipPath id="clip0_2180_42077">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const copy = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M17.6875 4.125L14.4062 0.875C14.1875 0.65625 13.875 0.53125 13.5625 0.53125H7.875C6.96875 0.53125 6.21875 1.28125 6.21875 2.1875V13.5938C6.21875 14.5 6.96875 15.25 7.875 15.25H16.375C17.2812 15.25 18.0312 14.5 18.0312 13.5938V4.96875C18.0312 4.65625 17.9062 4.34375 17.6875 4.125ZM14.4687 2.9375L15.6562 4.125H14.4687V2.9375ZM16.375 13.8438H7.875C7.75 13.8438 7.625 13.7188 7.625 13.5938V2.1875C7.625 2.0625 7.75 1.9375 7.875 1.9375H13.0625V4.8125C13.0625 5.1875 13.375 5.53125 13.7812 5.53125H16.625V13.625C16.625 13.75 16.5 13.8438 16.375 13.8438Z"
      fill="#012169"
    />
    <path
      d="M13.7812 7.03125H9.65625C9.28125 7.03125 8.9375 7.34375 8.9375 7.75C8.9375 8.15625 9.25 8.46875 9.65625 8.46875H13.7812C14.1562 8.46875 14.5 8.15625 14.5 7.75C14.5 7.34375 14.1562 7.03125 13.7812 7.03125Z"
      fill="#111928"
    />
    <path
      d="M13.7812 9.65625H9.65625C9.28125 9.65625 8.9375 9.96875 8.9375 10.375C8.9375 10.75 9.25 11.0938 9.65625 11.0938H13.7812C14.1562 11.0938 14.5 10.7813 14.5 10.375C14.4688 9.96875 14.1562 9.65625 13.7812 9.65625Z"
      fill="#111928"
    />
    <path
      d="M13.0625 16.25C12.6875 16.25 12.3437 16.5625 12.3437 16.9688V17.8125C12.3437 17.9375 12.2187 18.0625 12.0937 18.0625H3.625C3.5 18.0625 3.375 17.9375 3.375 17.8125V6.375C3.375 6.25 3.5 6.125 3.625 6.125H4.6875C5.0625 6.125 5.40625 5.8125 5.40625 5.40625C5.40625 5 5.09375 4.6875 4.6875 4.6875H3.625C2.71875 4.6875 1.96875 5.4375 1.96875 6.34375V17.8125C1.96875 18.7188 2.71875 19.4688 3.625 19.4688H12.125C13.0312 19.4688 13.7812 18.7188 13.7812 17.8125V16.9688C13.7812 16.5625 13.4687 16.25 13.0625 16.25Z"
      fill="#111928"
    />
  </svg>
);

export const fileIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M20.5873 6.2248L15.4123 1.1248C15.1123 0.824805 14.6998 0.674805 14.2873 0.674805H5.2873C4.0123 0.674805 2.9248 1.7248 2.9248 3.0373V21.0373C2.9248 22.3123 3.9748 23.3998 5.2873 23.3998H18.6748C19.9498 23.3998 21.0373 22.3498 21.0373 21.0373V7.3498C21.0373 6.9373 20.8873 6.5248 20.5873 6.2248ZM15.4498 3.5248L18.2623 6.2998H15.4498V3.5248ZM18.7123 21.6748H5.2873C4.9123 21.6748 4.6123 21.3748 4.6123 20.9998V2.9998C4.6123 2.6248 4.9123 2.3248 5.2873 2.3248H13.7623V7.1248C13.7623 7.5748 14.1373 7.9873 14.6248 7.9873H19.3873V20.9998C19.3498 21.3748 19.0498 21.6748 18.7123 21.6748Z" fill="#1F2A37"/>
<path d="M14.5873 10.9121H8.09981C7.64981 10.9121 7.2373 11.2871 7.2373 11.7746C7.2373 12.2621 7.61231 12.6371 8.09981 12.6371H14.5873C15.0373 12.6371 15.4498 12.2621 15.4498 11.7746C15.4498 11.2871 15.0748 10.9121 14.5873 10.9121Z" fill="#1F2A37"/>
<path d="M14.5873 15.0371H8.09981C7.64981 15.0371 7.2373 15.4121 7.2373 15.8996C7.2373 16.3871 7.61231 16.7621 8.09981 16.7621H14.5873C15.0373 16.7621 15.4498 16.3871 15.4498 15.8996C15.4498 15.4121 15.0748 15.0371 14.5873 15.0371Z" fill="#1F2A37"/>
</svg>
);

export const lock = (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
<path d="M12.2502 4.95005V4.30005C12.2502 2.30005 10.7502 0.600051 8.8502 0.450051C7.8002 0.350051 6.7502 0.725051 5.9752 1.42505C5.2002 2.12505 4.7502 3.12505 4.7502 4.15005V4.95005C3.3002 5.22505 2.2002 6.50005 2.2002 8.05005L2.2002 12.5751C2.2002 14.225 3.5502 15.5501 5.1752 15.5501L11.7752 15.5501C13.4252 15.5501 14.7752 14.2001 14.7752 12.5501V8.00005C14.8002 6.50005 13.7002 5.25005 12.2502 4.95005ZM6.7252 2.25005C7.2752 1.75005 8.0002 1.50005 8.7502 1.57505C10.0752 1.70005 11.1252 2.90005 11.1252 4.30005V4.87505H5.8752V4.12505C5.8752 3.42505 6.1752 2.75005 6.7252 2.25005ZM13.6752 12.5751C13.6752 13.6 12.8252 14.4501 11.8002 14.4501L5.2002 14.4501C4.1752 14.4501 3.3502 13.6251 3.3502 12.6001L3.3502 8.05005C3.3502 6.92505 4.2502 6.02505 5.3752 6.02505L11.6252 6.02505C12.7502 6.02505 13.6752 6.92505 13.6752 8.00005V12.5751Z" fill="#8899A8"/>
<path d="M8.4998 8.625C8.1998 8.625 7.9248 8.875 7.9248 9.2V11.825C7.9248 12.125 8.1748 12.4 8.4998 12.4C8.7998 12.4 9.0748 12.15 9.0748 11.825V9.175C9.0748 8.875 8.7998 8.625 8.4998 8.625Z" fill="#8899A8"/>
</svg>
);

export const warning = (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M19.4066 12.9089L12.7191 2.14844C12.1878 1.42969 11.3753 1.02344 10.5003 1.02344C9.5941 1.02344 8.7816 1.42969 8.2816 2.14844L1.5941 12.9089C0.969098 13.7526 0.875348 14.8464 1.3441 15.7839C1.81285 16.7214 2.75035 17.3151 3.81285 17.3151H17.1878C18.2503 17.3151 19.1878 16.7214 19.6566 15.7839C20.1253 14.8776 20.0316 13.7526 19.4066 12.9089ZM18.4066 15.1589C18.1566 15.6276 17.7191 15.9089 17.1878 15.9089H3.81285C3.2816 15.9089 2.8441 15.6276 2.5941 15.1589C2.37535 14.6901 2.4066 14.1589 2.7191 13.7526L9.4066 2.99219C9.6566 2.64844 10.0628 2.42969 10.5003 2.42969C10.9378 2.42969 11.3441 2.61719 11.5941 2.99219L18.2816 13.7526C18.5941 14.1589 18.6253 14.6901 18.4066 15.1589Z" fill="#BA0C2F"/>
  <path d="M10.5 6.83594C10.125 6.83594 9.78125 7.14844 9.78125 7.55469V10.9609C9.78125 11.3359 10.0937 11.6797 10.5 11.6797C10.9063 11.6797 11.2188 11.3672 11.2188 10.9609V7.52344C11.2188 7.14844 10.875 6.83594 10.5 6.83594Z" fill="#BA0C2F"/>
  <path d="M10.5 12.5C10.125 12.5 9.78125 12.8125 9.78125 13.2187V13.375C9.78125 13.75 10.0937 14.0938 10.5 14.0938C10.9063 14.0938 11.2187 13.7812 11.2187 13.375V13.1875C11.2187 12.8125 10.875 12.5 10.5 12.5Z" fill="#BA0C2F"/>
  </svg>
)